export const TILE_CONSTANTS = {
  DOC_TYPE: {
    EXPENSES: 'expenses',
    STATEMENTS: 'statements',
  },
};
